import React, { } from 'react';
import { useDispatch } from 'react-redux';

import { CollectionServer, GET, Model, POST, POSTFormData, QueryDetail, QueryOrder, deleteInArray, errorCatch, updateInArray, ycStorage } from 'fennec-ui';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import confirmKey from '../../components/ConfirmKeyModal';
import PageLayout from '../../components/PageLayout';
import YImage from '../../../common/YImage';
import { ycBucket } from '../../../common/Tool';
var _ = require('lodash');

export default function FederationadministratorSettingsAd(props) {
    const dispatch = useDispatch();
    const { auth } = props;

    const filters = () => [
        // {
        //     label: "Идентификатор",
        //     name: "ID",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "opisanie",
            sort: true,
            filter: true,
        },
        {
            label: "Дата создания",
            name: "createdAt",
            type: "date",
            sort: true,
            filter: true,
        }
    ];
    const render = (item, idx, { setCollection, setCollectionItem, update }) => {
        return (<div key={idx} style={{ padding: "10px 0px", width: "100%", borderTop: "1px solid #eee" }}>
            <div style={{ display: "flex", gap: "5px" }}>
                <div style={{ flex: "0 0" }}>
                    {item?.file?.fileType?.groupe == "image" && <YImage image={item?.file?.path} minimage={item?.file?.path} width={78} />}
                    {item?.file?.fileType?.groupe == "video" && <video src={ycStorage(auth) + ycBucket(auth) + "/" + item?.file?.path} style={{ width: "78px" }}></video>}
                </div>
                <div style={{ flex: "1 1 auto" }}>
                    <div>
                        {item.opisanie}
                    </div>
                </div>
            </div>
        </div>)
    }

    // POST "/api/reklama/new"
    // POST "/api/reklama/update"
    // "/api/reklama/delete/{id}"
    // "/api/reklama/bymeropriyatieid/{id}"
    // "/api/reklama/byid/{id}"
    // "/api/reklama/federation-list"

    const ctx = {}
    return (
        <PageLayout>
            <div style={{ padding: "15px 10px", backgroundColor: "white" }}>
                <CollectionServer
                    name={"Reklama"}
                    auth={auth}
                    size="small"

                    source={`/api/reklama/federation-list`}
                    filters={filters}

                    mode={"list"}
                    render={render}

                    collectionActions={() => [
                        {
                            isFormData: true,
                            modify: (values) => {
                                return { ...values, ...((ctx) ? ctx : {}) }
                            },
                            action: (values, unlock, close, { collection, setCollection }) => {
                                POSTFormData(auth, `/api/reklama/new`, values,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    },
                                    (err) => errorCatch(err, unlock));
                            },
                            form: Model,
                            meta: [
                                {
                                    label: "Описание",
                                    name: "opisanie",
                                    type: "text",
                                },
                                {
                                    label: "Файл",
                                    name: "file",
                                    type: "file",
                                }
                            ],
                            options: {
                                initialValues: {},
                            },
                            title: "Добавить рекламу",
                            modal: {
                                width: "600px",
                                title: "Новая реклама",
                            }
                        }
                    ]}
                    modelActions={(item) => [
                        {
                            isFormData: true,
                            modify: (values) => {
                                return { ...values, ...((ctx) ? ctx : {}) }
                            },

                            action: (values, unlock, close, { collection, setCollection }) => {
                                let o = {
                                    ID: item.ID,
                                    ...values
                                }
                                POSTFormData(auth, `/api/reklama/update`, o,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            object: item,
                            form: Model,
                            meta: [
                                {
                                    label: "Описание",
                                    name: "opisanie",
                                    type: "text",
                                },
                                {
                                    type: "func",
                                    render: (auth, item, { data, object, contextObject, funcStat }) => {
                                        if (!object || !object?.file) return (<React.Fragment></React.Fragment>);

                                        return (<div style={{ display: "flex", alignContent: "center", alignItems: "center", justifyContent: "center" }}>
                                            {object?.file?.fileType?.groupe == "image" && <YImage image={object?.file?.path} minimage={object?.file?.path} width={385} />}
                                            {object?.file?.fileType?.groupe == "video" && <video controls src={ycStorage(auth) + ycBucket(auth) + "/" + object?.file?.path} style={{ width: "385px" }}></video>}
                                        </div>)
                                    }
                                },
                                {
                                    label: "Файл",
                                    name: "file",
                                    type: "file",
                                }
                            ],
                            options: {
                                initialValues: {},
                            },
                            title: "Изменить",
                            modal: {
                                width: "450px",
                                title: <div>
                                    <div>Изменить рекламу</div>
                                    {/* <div style={{ fontSize: "14px" }}>{object?.nazvanie} {(object?.sezon?.nazvanie) ? "(" + object?.sezon?.nazvanie + ")" : ""}</div> */}
                                </div>
                            }
                        },
                        {
                            title: <span style={{ color: "red" }}>Удалить</span>,
                            action: (values, unlock, close, { collection, setCollection }) => {
                                Modal.confirm({
                                    title: `Вы уверены что хотите удалить рекламу?`,
                                    icon: <ExclamationCircleOutlined />,
                                    content: <span>{item.opisanie}</span>,
                                    okText: "Да",
                                    okType: 'danger',
                                    cancelText: "Нет",
                                    onOk: () => {
                                        GET(auth, `/api/reklama/delete/${item.ID}`,
                                            () => {
                                                setCollection(deleteInArray(collection, item))
                                            }, errorCatch
                                        );
                                    },
                                });
                            },
                        }
                    ]}
                />
            </div>
        </PageLayout>
    );
}
